import React, { useEffect, useState, useRef } from 'react';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, CircularProgress, Autocomplete, TextField, Chip, Dialog, DialogTitle, Button, MenuItem, DialogContent, Rating
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import AirlineSeatReclineExtraIcon from '@mui/icons-material/AirlineSeatReclineExtra';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const STATUS_OPTIONS = [
  "pending", "cancelled", "in-progress", "not-available"
];

const LOCATION_OPTIONS = [
  "Rachenahalli 1",
  "Rachenahalli 2",
  "Rachenahalli 3",
  "HegdeNagar 1",
  "HegdeNagar 2",
  "Bharatiya City 1",
  "Bharatiya City 2",
  "Bharatiya City 3",
  "Kannur 1",
  "Kannur 2",
  "Kannur 3",
  "WebCity 1",
  "WebCity 2",
  "Kothanur 1",
  "Kothanur 2",
  "Kothanur- Narayanpura 1",
  "Kothanur- Narayanpura 2",
  "Kothanur- Narayanpura 3",
  "Byrathi 1",
  "Hennur Main Road 1",
  "Hennur Cross 1",
  "Ashwath nagar 1"
];

const WashesTable = ({ status }) => {
  const [washes, setWashes] = useState([]);
  const [washers, setWashers] = useState([]);
  const [selectedWasher, setSelectedWasher] = useState(null);
  const [washerQuery, setWasherQuery] = useState('');
  const [washerLoading, setWasherLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [statusFilter, setStatusFilter] = useState(status ? [status] : ['pending']);
  const [editStatusId, setEditStatusId] = useState(null);
  const [editStatusValue, setEditStatusValue] = useState('');
  const [editStatusOpen, setEditStatusOpen] = useState(false);
  const [locationFilter, setLocationFilter] = useState(null);
  const [editDateTimeId, setEditDateTimeId] = useState(null);
  const [editDateTimeValue, setEditDateTimeValue] = useState('');
  const [editDateTimeOpen, setEditDateTimeOpen] = useState(false);
  const [editWasherOpen, setEditWasherOpen] = useState(false);
  const [editWasherId, setEditWasherId] = useState(null);
  const [editWasher, setEditWasher] = useState(null);
  const [editWasherQuery, setEditWasherQuery] = useState('');
  const [editWasherOptions, setEditWasherOptions] = useState([]);
  const [editWasherLoading, setEditWasherLoading] = useState(false);
  const [editNotesOpen, setEditNotesOpen] = useState(false);
  const [editNotesId, setEditNotesId] = useState(null);
  const [editNotesValue, setEditNotesValue] = useState('');
  const [customerNameFilter, setCustomerNameFilter] = useState('');
  const [carRegNoFilter, setCarRegNoFilter] = useState('');
  const [fromDateFilter, setFromDateFilter] = useState('');
  const [toDateFilter, setToDateFilter] = useState('');
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [userModalLoading, setUserModalLoading] = useState(false);
  const [userModalData, setUserModalData] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalUrl, setImageModalUrl] = useState('');
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [feedbackModalData, setFeedbackModalData] = useState(null);
  const editWasherDebounceRef = useRef(); // <-- define the ref here
  const debounceRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Reset filters when URL changes
    setSelectedWasher(null);
    setWasherQuery('');
    setLocationFilter(null);
    setCustomerNameFilter('');
    setCarRegNoFilter('');
    setFromDateFilter('');
    setToDateFilter('');
    setStatusFilter(status ? [status] : ['pending']);
    setPage(0);
    setRowsPerPage(10);
    // eslint-disable-next-line
  }, [location.pathname]);

  useEffect(() => {
    fetchWashes('');
    // eslint-disable-next-line
  }, [selectedWasher, page, rowsPerPage, statusFilter, locationFilter, carRegNoFilter, customerNameFilter, fromDateFilter, toDateFilter, status]);

  const fetchWashers = (search) => {
    setWasherLoading(true);
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/washers/options?search=${encodeURIComponent(search)}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(result => {
        setWashers(result || []);
        setWasherLoading(false);
      })
      .catch(() => {
        setWashers([]);
        setWasherLoading(false);
      });
  };

  const fetchWashes = () => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    let url = `${process.env.REACT_APP_SERVER_URI}/washes/list?page=${page + 1}&limit=${rowsPerPage}&table=true`;
    if (selectedWasher && selectedWasher._id) {
      url += `&washerId=${selectedWasher._id}`;
    }
    if ((statusFilter && statusFilter.length > 0) || status) {
      url += `&status=${encodeURIComponent((statusFilter || []).join(','))}`;
    }
    else if (status) {
      url += `&status=${encodeURIComponent(status)}`;
    }
    else{
       url+= `&isOrderPage=true`;
      }
    if (locationFilter) url += `&location=${encodeURIComponent(locationFilter)}`;
    if (customerNameFilter) url += `&customerNameRegex=${encodeURIComponent(customerNameFilter)}`;
    if (carRegNoFilter) url += `&carRegNoRegex=${encodeURIComponent(carRegNoFilter)}`;
    if (fromDateFilter && toDateFilter) {
      const from = new Date(fromDateFilter);
      from.setHours(0, 0, 0, 0);
      const to = new Date(toDateFilter);
      to.setHours(23, 59, 59, 999);
      url += `&from=${encodeURIComponent(from.toISOString())}&to=${encodeURIComponent(to.toISOString())}`;
    }
    // Always add sort to url
    url += `&sort=${encodeURIComponent(JSON.stringify({ date: status ? -1 : 1 }))}`;
    console.log('Fetching washes from:', url);
    fetch(url, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(result => {
        console.log('Fetched washes:', result.data);
        setWashes(result.data || []);
        setTotal(result.total || 0);
      })
      .catch(() => {
        setWashes([]);
        setTotal(0);
      });
  };

  const fetchEditWasherOptions = (search = '') => {
    setEditWasherLoading(true);
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/washers/options?search=${encodeURIComponent(search)}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(result => {
        setEditWasherOptions(result || []);
        setEditWasherLoading(false);
      })
      .catch(() => {
        setEditWasherOptions([]);
        setEditWasherLoading(false);
      });
  };

  const handleWasherInputChange = (event, value) => {
    setWasherQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchWashers(value);
    }, 400);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    // Convert UTC to IST for display
    const utcDate = new Date(dateStr);
    // const istDate = new Date(utcDate.getTime() + (5.5 * 60 * 60000));
    const day = String(utcDate.getDate()).padStart(2, '0');
    const month = String(utcDate.getMonth() + 1).padStart(2, '0');
    const year = utcDate.getFullYear();
    const time = utcDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return `${day}/${month}/${year} ${time}`;
  };

  const handleEditStatusOpen = (wash) => {
    setEditStatusId(wash._id);
    setEditStatusValue(wash.status || '');
    setEditStatusOpen(true);
  };

  // Unified update function for wash fields
  const updateWashField = async (washId, updateObj, onSuccess) => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    try {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URI}/washes/update/${washId}`, {
        method: 'POST',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateObj),
      });
      await res.json();
      setWashes(washes =>
        washes.map(w =>
          w._id === washId ? { ...w, ...updateObj } : w
        )
      );
      if (onSuccess) onSuccess();
    } catch {
      alert('Failed to update wash.');
    }
  };

  const handleEditStatusSave = async () => {
    console.log(editStatusValue, editStatusId);
    if (!editStatusId) return;
    await updateWashField(editStatusId, { status: editStatusValue }, () => {
      setEditStatusOpen(false);
      setEditStatusId(null);
      setEditStatusValue('');
    });
  };

  const handleEditDateTimeOpen = (wash) => {
    setEditDateTimeId(wash._id);
    if (wash.date) {
      const utcDate = new Date(wash.date);
      // Convert UTC to IST
      // const istDate = new Date(utcDate.getTime() + (5.5 * 60 * 60000));
      
      // If time is 00:00:00, set to 09:00:00 in IST
      // if (istDate.getHours() === 0 && istDate.getMinutes() === 0 && istDate.getSeconds() === 0) {
      //   istDate.setHours(9, 0, 0, 0);
      // }
      
      // Format as datetime-local (YYYY-MM-DDTHH:MM)
      const year = utcDate.getFullYear();
      const month = String(utcDate.getMonth() + 1).padStart(2, '0');
      const day = String(utcDate.getDate()).padStart(2, '0');
      const hours = String(utcDate.getHours()).padStart(2, '0');
      const minutes = String(utcDate.getMinutes()).padStart(2, '0');
      
      setEditDateTimeValue(`${year}-${month}-${day}T${hours}:${minutes}`);
    } else {
      setEditDateTimeValue('');
    }
    setEditDateTimeOpen(true);
  };

  const handleEditDateTimeSave = () => {
    if (!editDateTimeId) return;
    // Parse the datetime-local value and convert IST to UTC
    const [datePart, timePart] = editDateTimeValue.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);
    
    // Create IST date
    const istDate = new Date(year, month - 1, day, hours, minutes, 0, 0);
    
    // Convert IST to UTC (subtract 5.5 hours)
    // const utcDate = new Date(istDate.getTime());
    
    updateWashField(editDateTimeId, { date: istDate.toISOString() }, () => {
      setEditDateTimeOpen(false);
      setEditDateTimeId(null);
      setEditDateTimeValue('');
    });
  };

  const handleEditWasherOpen = (wash) => {
    setEditWasherId(wash._id);
    setEditWasher(wash.washer || null);
    setEditWasherQuery(wash.washerName || '');
    setEditWasherOptions([{ _id: wash.washer, name: wash.washerName }]);
    setEditWasherOpen(true);
    fetchEditWasherOptions(wash.washerName || '');
  };

  const handleEditWasherInputChange = (event, value) => {
    setEditWasherQuery(value);
    if (editWasherDebounceRef.current) clearTimeout(editWasherDebounceRef.current);
    editWasherDebounceRef.current = setTimeout(() => {
      fetchEditWasherOptions(value);
    }, 400);
  };

  const handleEditWasherSave = () => {
    if (!editWasherId || !editWasher) return;
    updateWashField(editWasherId, { washerId: editWasher._id, washerName: editWasher.name }, () => {
      setEditWasherOpen(false);
      setEditWasherId(null);
      setEditWasher(null);
      setEditWasherQuery('');
      setEditWasherOptions([]);
    });
  };

  const handleEditNotesOpen = (wash) => {
    setEditNotesId(wash._id);
    setEditNotesValue(wash.adminNote || '');
    setEditNotesOpen(true);
  };

  const handleEditNotesSave = async () => {
    console.log(editNotesValue, editNotesId);
    if (!editNotesId) return;
    await updateWashField(editNotesId, { adminNote: editNotesValue }, () => {
      setEditNotesOpen(false);
      setEditNotesId(null);
      setEditNotesValue('');
    });
  };

  const handleNameClick = (wash) => {
    setUserModalOpen(true);
    setUserModalLoading(true);
    setUserModalData(null);
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/users/${wash.userId}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    })
      .then(res => res.json())
      .then(data => {
        setUserModalData(data);
        setUserModalLoading(false);
      })
      .catch(() => {
        setUserModalData(null);
        setUserModalLoading(false);
      });
  };

  const handleClearDateFilters = () => {
    setFromDateFilter('');
    setToDateFilter('');
  };

  const [editLocationOpen, setEditLocationOpen] = useState(false);
  const [editLocationId, setEditLocationId] = useState(null);
  const [editLocationValue, setEditLocationValue] = useState('');

  const handleEditLocationOpen = (wash) => {
    setEditLocationId(wash.carId);
    setEditLocationValue(wash.carLocation || '');
    setEditLocationOpen(true);
  };

  const handleEditLocationSave = () => {
    if (!editLocationId) return;
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/cars/update-location/${editLocationId}`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ location: editLocationValue }),
    })
      .then(res => res.json())
      .then(() => {
        setWashes(washes =>
          washes.map(w =>
            w.carId === editLocationId ? { ...w, carLocation: editLocationValue } : w
          )
        );
        setEditLocationOpen(false);
        setEditLocationId(null);
        setEditLocationValue('');
      })
      .catch(() => {
        alert('Failed to update location.');
      });
  };

  const handleFeedbackClick = (wash) => {
    setFeedbackModalData({
      id: wash._id,
      rating: wash.rating || 0,
      feedback: wash.feedback,
      userName: wash.userName,
      userPhone: wash.userPhone
    });
    setFeedbackModalOpen(true);
  };

  const updateRating = (id, newValue) => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/washes/update-rating/${id}`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ rating: newValue }),
    })
      .then(res => res.json())
      .then(() => {
        setWashes(washes =>
          washes.map(w =>
            w._id === id ? { ...w, rating: newValue } : w
          )
        );
      })
      .catch(() => {
        alert('Failed to update rating.');
      });
  };
console.log(process.env)
  const handleFeedbackSubmit = () => {
    const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
    fetch(`${process.env.REACT_APP_SERVER_URI}/washes/updateReview/${feedbackModalData.id}`, {
      method: 'POST',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        review: feedbackModalData.feedback
      }),
    })
      .then(res => res.json())
      .then((data) => {
        console.log(data);
        setFeedbackModalOpen(false);
        setFeedbackModalData(null);
      })
      .catch(() => {
        alert('Failed to submit feedback.');
      });
  };

  console.log(washes)
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>Washes Table</Typography>
      <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        <Autocomplete
          options={washers}
          getOptionLabel={option => option.name + (option.phone ? ` (${option.phone})` : '')}
          loading={washerLoading}
          value={selectedWasher}
          onChange={(event, value) => setSelectedWasher(value)}
          inputValue={washerQuery}
          onInputChange={handleWasherInputChange}
          sx={{ minWidth: 250, maxWidth: 350 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filter by Washer"
              margin="normal"
              fullWidth
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {washerLoading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
        {!status && <Autocomplete
          multiple
          options={STATUS_OPTIONS}
          value={statusFilter}
          onChange={(event, value) => setStatusFilter(value)}
          disableCloseOnSelect
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip label={option} {...getTagProps({ index })} key={option} />
            ))
          }
          renderInput={(params) => (
            <TextField {...params} label="Status" margin="normal" />
          )}
          sx={{ minWidth: 200, maxWidth: 250 }}
        />}
        <Autocomplete
          options={LOCATION_OPTIONS}
          value={locationFilter}
          onChange={(event, value) => setLocationFilter(value)}
          sx={{ minWidth: 200, maxWidth: 250 }}
          renderInput={(params) => (
            <TextField {...params} label="Street" margin="normal" />
          )}
        />
        <TextField
          label="Customer Name"
          value={customerNameFilter}
          onChange={e => setCustomerNameFilter(e.target.value)}
          size="small"
          sx={{ minWidth: 180 }}
        />
        <TextField
          label="Car Reg No"
          value={carRegNoFilter}
          onChange={e => setCarRegNoFilter(e.target.value)}
          size="small"
          sx={{ minWidth: 180 }}
        />
        <TextField
          label="From Date"
          type="date"
          value={fromDateFilter}
          onChange={e => setFromDateFilter(e.target.value)}
          size="small"
          sx={{ minWidth: 150 }}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="To Date"
          type="date"
          value={toDateFilter}
          onChange={e => setToDateFilter(e.target.value)}
          size="small"
          sx={{ minWidth: 150 }}
          InputLabelProps={{ shrink: true }}
        />
        <Button
          variant="outlined"
          size="small"
          onClick={handleClearDateFilters}
          disabled={!fromDateFilter && !toDateFilter}
          sx={{ minHeight: 40 }}
        >
          Clear Dates
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>...</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Date & Time</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Washer</TableCell>
              <TableCell>Car</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Notes</TableCell>
              {status === 'completed' && <TableCell>Rating</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {washes.map((wash) => (
              <TableRow key={wash._id}>
                <TableCell>
                  <>
                  <IconButton
                    onClick={async () => {
                      const confirm = window.confirm(wash.interior?'Mark interior wash':'Unmark interior wash');
                      if (!confirm) return;
                      const token = JSON.parse(localStorage.getItem('auth_token_crm'))?.token;
                      try {
                        await fetch(`${process.env.REACT_APP_SERVER_URI}/washes/update/${wash._id}`, {
                          method: 'POST',
                          headers: {
                            Authorization: token ? `Bearer ${token}` : '',
                            'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({ interior: !wash.interior }),
                        });
                        setWashes(ws =>
                          ws.map(w =>
                            w._id === wash._id ? { ...w, interior: !w.interior } : w
                          )
                        );
                        alert(wash.interior ? 'Interior wash marked!' : 'Interior wash unmarked!');
                      } catch {
                        alert('Failed to update interior status.');
                      }
                    }}
                    >
                    <AirlineSeatReclineExtraIcon
                      fontSize="large"
                      sx={{
                        color: wash.interior
                        ? 'text.primary'
                        : 'rgba(0,0,0,0.15)'
                      }}
                    />
                    </IconButton>
                    {['waterless', 'bucket', 'jet-spray', 'full-wash'].includes(wash.washType) && <img
                      src={wash.washType === 'waterless'?"/dusting.png" : wash.washType === 'bucket' ?"/bucket.png":  wash.washType === 'jet-spray'? 'jetSpray.png' : wash.washType === 'full-wash'? 'fullwash.png':""}
                      alt="Wash Type"
                      style={{
                        width: 30,
                        height: 30,
                        objectFit: 'contain',
                        borderRadius: 2,
                        marginRight: 2,
                      }}
                    />}
                    </>
                  </TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                      <Box display="flex" alignItems="center">
                        <IconButton
                          size="small"
                          sx={{ ml: 1 }}
                          onClick={() => navigate(`/users/${wash.userId}`)}
                          title="Go to User page"
                        >
                          <OpenInNewIcon fontSize="small" />
                        </IconButton>
                        <Button
                          variant="text"
                          sx={{ textTransform: 'none', fontWeight: 600 }}
                          onClick={() => handleNameClick(wash)}
                        >
                          {wash.userName || '-'} {'(' + wash.userPhone + ')'}
                        </Button>
                      </Box>
                      {/* Eye icon for image modal on the right */}
                      <IconButton
                        size="small"
                        onClick={() => {
                          setImageModalOpen(true);
                          setImageModalUrl(wash.imageUrl);
                        }}
                        title="View Image"
                        disabled={!wash.imageUrl}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="currentColor" strokeWidth="2" fill="none"/>
                          <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="2" fill="none"/>
                        </svg>
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {wash.date ? formatDate(wash.date) : '-'}
                    <IconButton
                    size="small"
                    onClick={() => handleEditDateTimeOpen(wash)}
                    sx={{ ml: 1 }}
                    >
                    <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    {wash.status || '-'}
                    <IconButton
                    size="small"
                    onClick={() => handleEditStatusOpen(wash)}
                    sx={{ ml: 1 }}
                    >
                    <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    {wash.washerName + `(${wash.washerPhone})` || '-'}
                    <IconButton
                    size="small"
                    onClick={() => handleEditWasherOpen(wash)}
                    sx={{ ml: 1 }}
                    >
                    <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                  <TableCell>{wash.carRegNo || '-'}</TableCell>
                  <TableCell>
                    {wash.carLocation || '-'}
                    <IconButton
                    size="small"
                    onClick={() => handleEditLocationOpen(wash)}
                    sx={{ ml: 1 }}
                    >
                    <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    {wash.adminNote || '-'}
                    <IconButton
                    size="small"
                    onClick={() => handleEditNotesOpen(wash)}
                    sx={{ ml: 1 }}
                    >
                    <EditIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                  {status === 'completed' && (
                    <TableCell>
                      <Box 
                        sx={{ cursor: 'pointer' }}
                        onClick={() => handleFeedbackClick(wash)}
                      >
                        <Rating 
                          value={wash.rating || 0} 
                          readOnly 
                          size="small"
                        />
                      </Box>
                    </TableCell>
                  )}
                  </TableRow>
                ))}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={total}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
              />
              </TableContainer>
              {/* Image Modal */}
              <Dialog open={!!imageModalOpen} onClose={() => setImageModalOpen(false)} maxWidth="sm" fullWidth>
              <DialogTitle>Image</DialogTitle>
              <DialogContent>
                {imageModalUrl ? (
                <Box display="flex" flexDirection="column" alignItems="center">
                  <img src={imageModalUrl} alt="Wash" style={{ maxWidth: '100%', maxHeight: 400 }} />
                  <Typography variant="body2" sx={{ mt: 2, wordBreak: 'break-all' }}>
                  {imageModalUrl}
                  </Typography>
                </Box>
                ) : (
                <Typography>No image available.</Typography>
                )}
          </DialogContent>
        </Dialog>
      <Dialog open={editStatusOpen} onClose={() => setEditStatusOpen(false)}>
        <DialogTitle>Edit Status</DialogTitle>
        <Box px={3} py={2}>
          <TextField
            select
            label="Status"
            value={editStatusValue}
            onChange={e => setEditStatusValue(e.target.value)}
            fullWidth
            margin="normal"
          >
            {['completed', ...STATUS_OPTIONS].map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setEditStatusOpen(false)} sx={{ mr: 1 }}>Cancel</Button>
            <Button onClick={handleEditStatusSave} variant="contained" color="primary" disabled={!editStatusValue}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* Edit Date & Time Dialog */}
      <Dialog open={editDateTimeOpen} onClose={() => setEditDateTimeOpen(false)}>
        <DialogTitle>Edit Date & Time</DialogTitle>
        <Box px={3} py={2}>
          <TextField
            label="Date & Time (IST)"
            type="datetime-local"
            value={editDateTimeValue}
            onChange={e => setEditDateTimeValue(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setEditDateTimeOpen(false)} sx={{ mr: 1 }}>Cancel</Button>
            <Button onClick={handleEditDateTimeSave} variant="contained" color="primary">
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* Edit Washer Dialog */}
      <Dialog open={editWasherOpen} onClose={() => setEditWasherOpen(false)}>
        <DialogTitle>Change Washer</DialogTitle>
        <Box px={3} py={2}>
          <Autocomplete
            options={editWasherOptions}
            getOptionLabel={option => option.name || ''}
            loading={editWasherLoading}
            value={editWasher}
            onChange={(event, value) => setEditWasher(value)}
            inputValue={editWasherQuery}
            onInputChange={handleEditWasherInputChange}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Washer"
                margin="normal"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {editWasherLoading ? <CircularProgress size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setEditWasherOpen(false)} sx={{ mr: 1 }}>Cancel</Button>
            <Button onClick={handleEditWasherSave} variant="contained" color="primary" disabled={!editWasher}>
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* Edit Notes Dialog */}
      <Dialog open={editNotesOpen} onClose={() => setEditNotesOpen(false)}>
        <DialogTitle>Edit Notes</DialogTitle>
        <Box px={3} py={2}>
          <TextField
            label="Notes"
            value={editNotesValue}
            onChange={e => setEditNotesValue(e.target.value)}
            fullWidth
            multiline
            minRows={3}
            margin="normal"
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setEditNotesOpen(false)} sx={{ mr: 1 }}>Cancel</Button>
            <Button onClick={handleEditNotesSave} variant="contained" color="primary">
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
      {/* User Details Dialog */}
      <Dialog open={userModalOpen} onClose={() => setUserModalOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>User & Car Details</DialogTitle>
        <DialogContent>
          {userModalLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
              <CircularProgress />
            </Box>
          ) : userModalData ? (
            <Box>
              <Typography variant="h6" sx={{ mb: 1 }}>User Details</Typography>
              <Typography>Name: {userModalData.name || '-'}</Typography>
              <Typography>Email: {userModalData.email || '-'}</Typography>
              <Typography>Phone: {userModalData.phone || '-'}</Typography>
              <Typography>Address: {userModalData.address || '-'}</Typography>
              <Typography>Notes: {userModalData.notes || '-'}</Typography>
              <Box mt={2}>
                <Typography variant="h6" sx={{ mb: 1 }}>Cars</Typography>
                {Array.isArray(userModalData.cars) && userModalData.cars.length > 0 ? (
                  userModalData.cars.map((car, idx) => (
                    <Box key={idx} sx={{ mb: 2, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
                      <Typography>Car Name: {car.name || '-'}</Typography>
                      <Typography>Model: {car.model || '-'}</Typography>
                      <Typography>Reg No: {car.regNo || '-'}</Typography>
                      <Typography>Car Type: {car.type || '-'}</Typography>
                      <Typography>Location: {car.location || '-'}</Typography>
                      <Typography>Address: {car.address || '-'}</Typography>
                      <Typography>Notes: {car.notes || '-'}</Typography>
                      <Typography>
                        Google Maps:{' '}
                        {Array.isArray(car.gps) && car.gps.length === 2
                          ? (
                            <a
                              href={`https://www.google.com/maps?q=${car.gps?.[0]},${car.gps?.[1]}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {`[${car.gps[0]}, ${car.gps[1]}]`}
                            </a>
                          )
                          : '-'}
                      </Typography>
                      <Typography>
                        Car Free Time: {Array.isArray(car.carFreeTime) && car.carFreeTime.length > 0
                          ? car.carFreeTime.map((ft, i) =>
                              `${ft.day || '-'} ${ft.time || '-'}`
                            ).join(', ')
                          : '-'}
                      </Typography>
                    </Box>
                  ))
                ) : (
                  <Typography>No cars found.</Typography>
                )}
              </Box>
            </Box>
          ) : (
            <Typography>No user data found.</Typography>
          )}
        </DialogContent>
      </Dialog>
      {console.log(feedbackModalData)}
      {/* Feedback Modal */}
      <Dialog open={feedbackModalOpen} onClose={() => setFeedbackModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Customer Review</DialogTitle>
        <DialogContent>
          {feedbackModalData && (
            <Box sx={{ py: 2 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {feedbackModalData.userName} ({feedbackModalData.userPhone})
              </Typography>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>Rating:</Typography>
                <Box display="flex" alignItems="center">
                  <Rating
                    value={feedbackModalData.rating}
                    size="large"
                    onChange={(_, newValue) => {
                      if (newValue === null || newValue === feedbackModalData.rating) return;
                      if (window.confirm(`Update rating to ${newValue}?`)) {
                        // Find wash by userName and userPhone (or you can pass washId in feedbackModalData)
                        updateRating(feedbackModalData.id, newValue);
                      }
                    }}
                  />
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
                    {feedbackModalData.rating}/5 stars
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>Review:</Typography>
                <TextField
                    label="Review"
                    type="text"
                    multiline
                    minRows={3}
                    fullWidth
                    value={feedbackModalData.feedback}
                    onChange={e => setFeedbackModalData({
                      ...feedbackModalData,
                      feedback: e.target.value
                    })}
                    margin="normal"
                  />
                  <Button onClick={handleFeedbackSubmit}>Submit</Button>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      {/* Edit Location Dialog */}
      <Dialog open={editLocationOpen} onClose={() => setEditLocationOpen(false)}>
        <DialogTitle>Edit Location</DialogTitle>
        <Box px={3} py={2}>
          <TextField
            select
            label="Location"
            value={editLocationValue}
            onChange={e => setEditLocationValue(e.target.value)}
            fullWidth
            margin="normal"
          >
            {LOCATION_OPTIONS.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </TextField>
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button onClick={() => setEditLocationOpen(false)} sx={{ mr: 1 }}>Cancel</Button>
            <Button onClick={handleEditLocationSave} variant="contained" color="primary">
              Save
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default WashesTable;
